import { Component } from '@angular/core';
import { ToastGlobalService } from './toast-global.service';

@Component({
    selector: 'app-toast-global',
    templateUrl: './toast-global.component.html',
    styleUrls: ['./toast-global.component.css'],
    standalone: false
})
export class ToastGlobalComponent {

  constructor(public toastGlobalService: ToastGlobalService) { }
}
